// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__n4cUk","tabsBox":"styles_tabsBox__y9__E","createButton":"styles_createButton__3ni8q"};